import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from 'swiper/modules';
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { primarycolor } from "../Utils/colors";
import { useNavigate } from "react-router-dom";
import { isDesktop, isMobile, isTablet } from "react-device-detect";


const Categoriesslider = ({ categories }) => {
    const navigate = useNavigate()

    // const backgroundGradients = [
    //     'linear-gradient(to right, #FAD02E, rgb(146, 137, 137))',
    //     'linear-gradient(to right, #4CAF50, rgb(146, 137, 137))',
    //     'linear-gradient(to left, #FF6347, rgb(146, 137, 137))',
    //     'linear-gradient(to left, #2196F3, rgb(146, 137, 137))',
    //     'linear-gradient(to right, #FF9800, rgb(146, 137, 137))',
    // ];

    const backgroundGradients = [
        '#FAD02E',
        '#4CAF50',
        '#FF6347',
        '#2196F3',
        '#FF9800',
    ];

    return (
        <Swiper
            slidesPerView={2}
            spaceBetween={20}
            slidesPerGroup={3}
            autoplay={{
                delay: 2000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false
            }}
            loop={false}
            loopFillGroupWithBlank={true}
            shortSwipes={true}
            modules={[Pagination, Navigation]}
            color={primarycolor}
            pagination={false}
            navigation={false}
            style={{
                "--swiper-pagination-color": "#000",
                "--swiper-navigation-color": "#000",
                "--swiper-navigation-size": "20px"
            }}
        >
            {Array.isArray(categories) && categories.map((val, key) => {
                const backgroundGradient = backgroundGradients[key % backgroundGradients.length];

                return (
                    <SwiperSlide key={key} >
                        <div className="categorychild" onClick={() => navigate(`/categories/${val.item_group}`)} style={{ background: backgroundGradient }}>
                            {/* <div className="categorychildtitle" onClick={() => navigate("/typedevotions")}>{val.group_name?.substring(0,13)?.toUpperCase()}{val.group_name?.length > 13 && '..'}</div> */}
                            <div className="categorychildtitle">{val.group_name?.toUpperCase()}</div>
                        </div>
                    </SwiperSlide>
                )
            })

            }
        </Swiper>
    )
}

export default Categoriesslider